import styled, { WithTheme } from '@emotion/styled';
import { css, keyframes } from '@emotion/core';
import { variant } from 'styled-system';
import { StyledProps as Props, Theme } from './Spinner.types';

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const StyledSpinner = styled.div<Props, Theme>`
  ${(p: WithTheme<Props, Theme>) =>
    css({
      border: '0.2em solid rgba(0, 0, 0, 0.1)',
      borderTop: '0.2em solid #767676',
      borderRadius: '50%',
      width: p.size ? `${p.size}rem` : '3rem',
      height: p.size ? `${p.size}rem` : '3rem',
      animation: `${spin} 0.6s linear infinite`,
    })}

  ${variant({
    prop: 'mode',
    variants: {
      primary: {
        borderColor: 'var(--color-indigo-t1)',
        borderTopColor: 'var(--color-indigo)',
      },
      secondary: {
        borderColor: 'var(--color-vibrant-blue-t1)',
        borderTopColor: 'var(--color-vibrant-blue)',
      },
      success: {
        borderColor: 'rgba(55, 168, 105, 0.19)',
        borderTopColor: 'var(--color-vibrant-blue-t8)',
      },
      error: {
        borderColor: 'var(--color-coral-t1)',
        borderTopColor: 'var(--color-coral)',
      },
      warning: {
        borderColor: 'rgba(255, 96, 0, 0.2)',
        borderTopColor: 'var(--color-amber)',
      },
    },
  })}
`;
